import type { FaireProductEntity } from "../../entity_types/product";

export const p_rxqvqfkrbk: FaireProductEntity = {
  token: "p_rxqvqfkrbk",
  type: "product",
  name: "Lavender Flat Note Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/1e23e0929c20eaf0c23b23a2fd60e9d7e32a975e5e91e52f00c71ef27c151ea2.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4486a92a44b6aaf641f52d99398b71a5892819f5e601edc695a2c78b7e49f501.jpeg",
    "https://cdn.faire.com/fastly/1fdc9e4113fa1aba42996e7fec670bd346e80c4ca64ecae8bda57c1ab10a0dd4.jpeg",
  ],
  priceDollars: 8,
  description:
    'A flat note is concise and smart. Not ostentatious, but clever. And without too much room, you can get right to the point, or be "well-edited" as we like to say.\n\nThis set includes 8 envelopes and 8 beautifully illustrated notecards, each with an extra illustration on the back.',
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:37.412Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
